import {
  getBasicOwners as commonGetBasicOwners,
  getDefaultOwners as commonGetDefaultOwners,
  createGetFiltersParams,
  createGetFiltersQuery,
  createGetFetchFiltersParams,
  createFiltersSelector,
  createGetParsedFiltersFromURL,
  createGetFiltersAsQueryObject,
  createGetMetadataParams,
  createGetUsersParams,
} from '../../common/filters/selectors';
import { COMMON_FILTERS_MAP, FILTERS_MAP, RDC_COVERAGE_FILTERS_MAP } from './constants';

export const getUser = (store) => store.user;
export const getFilters = (store) => store.apps.analytics.rdc.filters;
export const getLocation = (store) => store.router.location;

export const getBasicOwners = commonGetBasicOwners;
export const getDefaultOwners = commonGetDefaultOwners;
export const getFiltersParams = createGetFiltersParams(getFilters, COMMON_FILTERS_MAP);
export const getFiltersParamsWithDeviceGroup = createGetFiltersParams(getFilters, FILTERS_MAP);
export const getCoverageFiltersParams = createGetFiltersParams(
  getFilters,
  RDC_COVERAGE_FILTERS_MAP,
);
export const getFiltersQuery = createGetFiltersQuery(getFilters);
export const getFiltersAsQueryObject = createGetFiltersAsQueryObject(getFilters, getFiltersQuery);
export const getFetchFiltersParams = createGetFetchFiltersParams(getFiltersParams);
export const filtersSelector = createFiltersSelector(getFilters);
export const getMetadataParams = createGetMetadataParams(getFiltersParams);
export const getParsedFiltersFromURL = createGetParsedFiltersFromURL(getFilters);
export const getUsersParams = createGetUsersParams(getFilters);
